import React, { PureComponent } from 'react';
import { ServicesProvider } from '@wix/experts-common';
import ExpertsListItem from './ExpertsListItem/ExpertsListItem';
import s from './expertsList.scss';

class ExpertsList extends PureComponent {
  componentDidMount() {
    const { total, filters } = this.props;
    this.context.services.withBI({
      evid: 15,
      filterValue: JSON.stringify(filters),
      numOfResults: total,
    });
  }

  render() {
    const {
      experts,
      onExpertProfileClick,
      onExpertProfileMinimalPriceClick,
      staticsBaseUrl,
    } = this.props;
    return (
      <ul className={s.root} data-hook="experts-list">
        {experts.map(expert => (
          <li className={s.expertsListItem} key={expert.id}>
            <ExpertsListItem
              expert={expert}
              onClick={onExpertProfileClick}
              onMinimalPriceClick={onExpertProfileMinimalPriceClick}
              staticsBaseUrl={staticsBaseUrl}
            />
          </li>
        ))}
      </ul>
    );
  }
}

ExpertsList.contextTypes = ServicesProvider.childContextTypes;

export default ExpertsList;
